<template>
  <div class="ActivityRewards">
    <my_title :content="title" :inputStyle="titleStyle"></my_title>
    <div class="content">
      <div class="rewards">
        <reward v-for="r in rewards" :key="r.title" :reward="r"></reward>
      </div>
      <div class="tips">
      </div>
    </div>
  </div>
</template>

<script>
 import MyTitle from '@/components/Title.vue';
 import Reward from '@/components/frontpage/Reward.vue';

 export default {
   name: '',
   props: ['rewards'],
   computed: {
     title () {
       return '奖项设置'
     },
     titleStyle () {
       return {
       }
     },
   },
   methods: {
   },
   components: {
     my_title: MyTitle,
     reward: Reward
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .ActivityRewards{
   display: flex;
   height: 30vw;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
 }
 .content .rewards{
   display: flex;
   width: 63vw;
   justify-content: space-between;
   align-items: center;
   flex-wrap: wrap;
 }
 .images{
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: space-between;
   /* width: 46vw; */
   height: 23.17vw;
 }
@media (min-width: 320px) and (max-width: 480px) {
  .ActivityHighlights{
    height: 47.62vw;
  }
  .content{
    width: 90vw;
  }
  .redfile{
    width: 22.9vw;
      height: 32.24vw;
  }
  .images{
    width: 64vw;
    height: 32.24vw;
  }
 }
</style>

